import store from "../index.js";

export default function translator(section, label) {
    let state = store.getState();
    let translations = state.language_translations;

    if(!translations) return ""; // Translations haven't loaded

    if(!translations[section] || !translations[section][label]) { // Wrong section/label used
        console.log("MISSING TRANSLATION: ", { section: section, label: label });
        return "";
    }
    return translations[section][label][state.selected_language];
}

export function translate_switch(versions) {
    let selected_language = store.getState().selected_language;
    if(!selected_language) return "";
    if(!versions[selected_language] && versions[selected_language] !== "") {
        console.log("MISSING TRANSLATION: ", selected_language, versions);
        return "";
    }
    return versions[selected_language];
}